// Style
import { cyan, deepOrange, green, lightBlue, orange, purple, red, yellow } from "@mui/material/colors/index.js";

export const trainingFocusColor = [
	red[600],           // Kraft
	green[600],         // Ausdauer
	yellow[600],        // Technik
	orange[600],        // Taktik
	purple[500],        // Koord.
	cyan[300],          // Schnelligkeit
	deepOrange["A400"], // Wettkampf/Liga
	lightBlue[800],     // Ruhetag
	lightBlue[900],     // Reisetag
	green[50]           // Training eingetragen
	];

//hellere Farben für Darstellung der Dauer in der Analyse
export const analysisDurationColor = [
	red[300],      
	green[300],     
	yellow[300],       
	orange[300],     
	purple[300],       
	cyan[200],       
	deepOrange["A200"], 
	lightBlue[300],  
	lightBlue[300],  
	green[50]          
];

//dunklere Farben für Darstellung der Intensität in der Analyse
export const analysisIntensityColor = [
	red[900],
	green[900],
	yellow[700],
	orange[800],
	purple[800],
	cyan[600],
	deepOrange["A700"],
	lightBlue[900],
	green[50]
];

export const analysisButtonBackgroundColor = orange[50];
export const bgColorLight = "#e9f2ef";    //Hintergrundfarbe für Athletenliste
export const bgColorToday = 'white';
export const borderRadius = '0';
export const borderStyle = '2px solid orange';
export const primaryColor = '#234d49';
export const primaryColorLight = '#357973';
export const selectedWeekFontColor = orange[500];

export const tealColorScheme = {
	analysisDurationColor,
	analysisIntensityColor,
	analysisButtonBackgroundColor,
	bgColorLight,
	bgColorToday,
	borderRadius,
	borderStyle,
	primaryColor,
	primaryColorLight,
	selectedWeekFontColor,
	trainingFocusColor
};